import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { YhBox } from "@components/YhBox";
import { Button } from "antd";
import { rateSetModel } from "../rateSetModel";
import { EditModeType } from "@src/types/FmsTypes";
import { YhAuth } from "@src/components/auth/YhAuth";

export const DataBox = () => {
    const { setEditType, setDrawerVisible} = rateSetModel();

    const onDetail = (type: EditModeType) => {
        setDrawerVisible(true)
        setEditType(type)
    }
    const action = (
        <>
           
        </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}